import {
    AutumnIcon, 
    SummerIcon, 
    SpringIcon, 
    WinterIcon, 
    HistoryIcon,
    StationIcon,
    RestaurantIcon,
    ElevatorIcon, 
    ToiletIcon, 
    SlopeIcon, 
    DefaultIcon
} from '../components/map/MapIcon.js'

export const getLink = (elem , path) => {
    let category = elem.category;
    if(path){
        return path + elem.id;
    }
    else if (category === 'flower') {
        return "/nature/" + elem.id;
    }
    else if (category === 'history') {
        return "/history/" + elem.id;
    }
    else if (category === 'station') {
        return "/station/" + elem.id;
    }
    else if (category === 'restaurant') {
        return "/facility/" + elem.id;
    }
    else if (category === 'elevator') {
        return "/barrier-free/" + elem.id;
    }
    else if (category === 'slope') {
        return "/barrier-free/" + elem.id;
    }
    else if (category === 'toilet') {
        return "/facility/" + elem.id;
    }
    else{
        console.log("Invalid category in getLink func.");
    }
};

export const getIcon = (fileName , defaultIcon) => {

  if(!defaultIcon){
    defaultIcon = DefaultIcon;
  }

  switch(fileName){
    case 'spring.png':
      return SpringIcon;
    case 'summer.png':
      return SummerIcon;
    case 'autumn.png':
      return AutumnIcon;
    case 'winter.png':
      return WinterIcon;
    case 'history.png':
      return HistoryIcon;
    case 'food-icon.png':
      return RestaurantIcon;
    case 'train-icon.png':
      return StationIcon;
    case 'elevator.svg':
      return ElevatorIcon;
    case 'toilet.svg':
      return ToiletIcon;
    case 'slope.svg':
      return SlopeIcon;
    default:
      return defaultIcon;
  }
} 
export const getTooltipOptions = (key, coordinate , category) => {
  let defaultOptions = {
    permanent: true,
    key: key,
    position: coordinate , 
    draggable: false, 
    interactive: true,
    opacity: 1,
    offset: [10, -10],
    className: ""
  };

  if (category === 'flower') {
    return {...defaultOptions , offset:[0, -75] };
  }
  else if (category === 'history') {
    return {...defaultOptions , className:"tooltip-history"};
  }
  else if (category === 'station') {
    return {...defaultOptions , className:"tooltip-station"};
  }
  else if (category === 'restaurant') {
    return {...defaultOptions , className:"tooltip-restaurant"};
  }
  else if (category === 'elevator') {
    return {...defaultOptions , offset:[0, -15]};
  }
  else if (category === 'slope') {
    return {...defaultOptions , offset:[0, -15]};
  }
  else if (category === 'toilet') {
    return {...defaultOptions , offset:[0, -10]};
  }
  else{
    console.log("Invalid category in getTooltipOptions func.");
  }
}